<template>
  <form ref="asyncForm" :action="formPath" @submit.prevent="submit" method="POST">
    <input :value="csrfToken" type="hidden" name="authenticity_token" />
    <input v-if="method !== 'POST'" :value="method" type="hidden" name="_method" />
    <slot></slot>
  </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AsyncForm",
  props: {
    formPath: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: "POST",
    },
  },
  computed: {
    ...mapGetters({
      csrfToken: "getCsrfToken",
    }),
  },
  methods: {
    ...mapActions({
      fetchCsrfToken: "fetchCsrfToken",
    }),
    async submit() {
      await this.fetchCsrfToken();
      this.$nextTick(function() {
        this.$refs.asyncForm.submit();
      });
    },
  },
};
</script>
